import { SubmissionError } from 'redux-form';
import { fetch } from '../../utils/dataAccess';

export function error(error) {
  return { type: 'ONEWAYINTERVIEW_SHARE_LINK_CREATE_ERROR', error };
}

export function loading(loading) {
  return { type: 'ONEWAYINTERVIEW_SHARE_LINK_CREATE_LOADING', loading };
}

export function success(created) {
  return { type: 'ONEWAYINTERVIEW_SHARE_LINK_CREATE_SUCCESS', created };
}

export function create(values, callback) {
  return dispatch => {
    dispatch(loading(true));

    return fetch('one_way_interview_share_links', { method: 'POST', data: values })
      .then(response => {
        dispatch(loading(false));
        dispatch(success(response.data));
        callback();
      })
      .catch(e => {
        dispatch(loading(false));

        if (e instanceof SubmissionError) {
          dispatch(error(e.errors._error));
          throw e;
        }

        dispatch(error(e.message));
        callback();
      });
  };
}

export function reset() {
  return dispatch => {
    dispatch(loading(false));
    dispatch(error(null));
    dispatch(success(null));
  };
}
